export default (input_depthSampler: string, input_bumpFactor = "0.0") => {
	return `

	float getHeight(vec2 uv) {
		vec4 depth4 = texture2D(${input_depthSampler}, uv);
		float depth = depth4.r;
		float roughness = depth4.g;
		float bumpFactor = ${input_bumpFactor};
		depth += (roughness * bumpFactor);
		return depth;
	}

	vec3 bumpFromDepth(vec2 uv, float height, float bumpScale, float stepSize) {
		float step = stepSize;

		// Fetch height values around the current pixel using the provided getHeight function
		float heightL = getHeight(uv + vec2(-step, 0.0));
		float heightR = getHeight(uv + vec2( step, 0.0));
		float heightD = getHeight(uv + vec2(0.0, -step));
		float heightU = getHeight(uv + vec2(0.0,  step));

		// Compute gradients
		float dX = heightR - heightL;
		float dY = heightU - heightD;

		// Construct the tangent space normal
		vec3 normal = normalize(vec3(-dX * bumpScale, -dY * bumpScale, 1.0));

		return normal;
	}
	`
}